import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent form submission
    // Step 4: Verify email and password
    if (email === 'admin@gmail.com' && password === '12345') {
     
      window.location.href = '/skills';
    } else {
      alert('Invalid User');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
      <form
        noValidate
        className="flex flex-col w-full max-w-lg p-8 rounded shadow-lg bg-yellow-50 dark:text-gray-100"
      >
        <label htmlFor="user-email" className="self-start text-xs font-semibold">
          Email:
        </label>
        <input
          type="email"
          id="user-email"
          value={email}
          onChange={handleEmailChange}
          className="h-12 px-4 mt-2 rounded focus:outline-none focus:ring-2 dark:text-gray-900 focus:ring-violet-400"
        />

        <label htmlFor="user-password" className="self-start mt-3 text-xs font-semibold">
          Password:
        </label>
        <input
          type="password"
          id="user-password"
          value={password}
          onChange={handlePasswordChange}
          className="h-12 px-4 mt-2 rounded focus:outline-none focus:ring-2 dark:text-gray-900 focus:ring-violet-400"
        />

        <button
          onClick={handleSubmit}
          type="submit"
          className="flex items-center justify-center h-12 mt-8 text-sm font-semibold rounded dark:bg-violet-400 border border-indigo-600 dark:text-gray-900 bg-teal-200"
        >
          Login
        </button>

        <div className="flex justify-center mt-6 space-x-2 text-xs">
          <Link to="#">Forgot password?</Link>
          <span>/</span>
          <Link to="#">Create an account</Link>
        </div>
      </form>
    </div>
  );
};

export default Login;
